import { KeyValuePair } from './KeyValuePair';

export interface PublicClientBasicInformation {
	title?: string;
	firstName: string;
	lastName: string;
	preferredName?: string;
	gender?: string;
	maritalStatus?: string;
	occupation?: string;
	dateOfBirth?: Date;
	mobilePhone: string;
	directorId: number;
	officeId: number;
	sourceOfReferral?: string;
	email: string;
	confirmEmail: string;
	isBusinessOwner: boolean;
}

export const createDefaultPublicClientBasicInformation = (): PublicClientBasicInformation => {
	return {
		title: null,
		firstName: null,
		lastName: null,
		preferredName: null,
		gender: null,
		maritalStatus: null,
		occupation: null,
		dateOfBirth: null,
		mobilePhone: null,
		directorId: null,
		officeId: null,
		sourceOfReferral: null,
		email: '',
		confirmEmail: '',
		isBusinessOwner: null
	};
};

export interface PublicClientInterests {
	interests?: string;
	otherInterests?: string;
}

export const createDefaultPublicClientInterests = (): PublicClientInterests => {
	return {
		interests: null,
		otherInterests: null
	};
};

export interface PublicClientFamily {
	clientId?: number;
	firstName: string;
	lastName: string;
	dateOfBirth: Date | string | null;
	relationship: string;
	financiallyDependent: boolean | null;
}

export const createDefaultFamilyMember = (familyMember: PublicClientFamily = null): PublicClientFamily => {
	return {
		clientId: familyMember?.clientId ?? null,
		firstName: familyMember?.firstName ?? null,
		lastName: familyMember?.lastName ?? null,
		dateOfBirth: familyMember?.dateOfBirth ?? null,
		relationship: familyMember?.relationship ?? null,
		financiallyDependent: familyMember?.financiallyDependent ?? false
	};
};

export interface PublicClientProfileSummary {
	basicInfo?: KeyValuePair[];
	familyMembers?: KeyValuePair[];
	entities: KeyValuePair[];
}
